import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { MultipleShippingCheckoutButtonComponent as OriginalComponent } from '../../shared/multiple-shipping-checkout-button/multiple-shipping-checkout-button.component';

@Component({
  selector: 'custom-lazy-multiple-shipping-checkout-button',
  templateUrl: './lazy-multiple-shipping-checkout-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyMultipleShippingCheckoutButtonComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/multiple-shipping-checkout/shared/multiple-shipping-checkout-button/multiple-shipping-checkout-button.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;



  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('multipleShippingCheckout').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../multiple-shipping-checkout.module`).then(m => m.MultipleShippingCheckoutModule);

    const { MultipleShippingCheckoutButtonComponent: originalComponent } = await import('../../shared/multiple-shipping-checkout-button/multiple-shipping-checkout-button.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.component.changeDetectorRef.markForCheck();
  }


}
